import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
 
  STAKEHOLDERREFERENCEGROUP_FEATURE_KEY,
  StakeholderReferenceGroupState,
  StakeholderReferenceGroupPartialState,
  stakeholderreferenceGroupAdapter
} from './stakeholderreferencegroup.reducer';




export const getStakeholderReferenceGroupState = createFeatureSelector<
StakeholderReferenceGroupPartialState,
StakeholderReferenceGroupState
>(STAKEHOLDERREFERENCEGROUP_FEATURE_KEY);



const { selectAll, selectEntities } = stakeholderreferenceGroupAdapter.getSelectors();

export const getStakeholderReferenceGroupLoaded = createSelector(
  getStakeholderReferenceGroupState,
  (state: StakeholderReferenceGroupState) => state.loaded
);



export const loadingByTypeStakeholderReferenceGroup = createSelector(
    getStakeholderReferenceGroupState,
  (state: StakeholderReferenceGroupState) =>  state.loaded
  );
  
  export const getAllByTypeStakeholderReferenceGroup = createSelector(
    getStakeholderReferenceGroupState,
  (state: StakeholderReferenceGroupState) => selectAll(state)
  );
  
  export const getByTypeStakeholderReferenceEntitiesGroup = createSelector(
    getStakeholderReferenceGroupState,
  (state: StakeholderReferenceGroupState) => selectEntities(state)
  );

  export const getSelectedId = createSelector(
    getStakeholderReferenceGroupState,
  (state: StakeholderReferenceGroupState) => state.selectedStakeholderReferenceGroupId
);

  export const getSelected = createSelector(
    getByTypeStakeholderReferenceEntitiesGroup,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);


